import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed } from 'vue';
import { Capacitor } from '@capacitor/core';
import { admobService } from '../services/admobService';
import { useConsentStore } from '../stores/consentStore';

interface Props {
  trigger?: 'download' | 'navigation' | 'manual';
  frequency?: number; // Show ad every N triggers
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileInterstitialAd',
  props: {
    trigger: { default: 'manual' },
    frequency: { default: 3 }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const consentStore = useConsentStore();
const triggerCount = ref(0);
const lastShownTime = ref(0);

const isNative = computed(() => Capacitor.isNativePlatform());
const shouldShowAd = computed(() => {
  return consentStore.canUseAdvertising && admobService.isEnabled() && isNative.value;
});

const canShowAd = computed(() => {
  const now = Date.now();
  const timeSinceLastAd = now - lastShownTime.value;
  const minInterval = 30000; // 30 seconds minimum between ads
  
  return shouldShowAd.value && 
         triggerCount.value % props.frequency === 0 && 
         timeSinceLastAd > minInterval;
});

const showInterstitialAd = async (): Promise<boolean> => {
  if (!canShowAd.value) {
    return false;
  }

  try {
    const success = await admobService.showInterstitialAd();
    if (success) {
      lastShownTime.value = Date.now();
      triggerCount.value = 0; // Reset counter after showing ad
    }
    return success;
  } catch (error) {
    console.error('Failed to show interstitial ad:', error);
    return false;
  }
};

const incrementTrigger = () => {
  triggerCount.value++;
};

// Expose methods to parent components
__expose({
  showInterstitialAd,
  incrementTrigger,
  canShowAd
});

return (_ctx: any,_cache: any) => {
  return false
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})